export const role = {
    manager: 1, // Quản lý
    coursecreator: 2, // Giáo viên biên soạn
    editingteacher: 3, // Giáo viên
    teacher: 4, // Giáo viên trợ giảng
    student: 5, // học viên
}

// Hiên thị tên vai trò
export const roleNames: Record<number, string> = {
    1: "roles.manager",
    2: "roles.courseCreator",
    3: "roles.teacher",
    4: "roles.teachingAssistant",
    5: "roles.student",
};
export const roleNameEn: Record<number, string> = {
    1: "roles.manager",
    2: "roles.courseCreator",
    3: "roles.teacher",
    4: "roles.teachingAssistant",
    5: "roles.student",
}
